/** Native hash links work without JS; enhance focus, scrolling and the current chapter. */
export function initializeArticleContents(root = document) {
    const win = root.defaultView || root.ownerDocument.defaultView;
    const doc = root.ownerDocument || root;
    root.querySelectorAll('[data-article-contents]').forEach((nav) => {
        const entries = Array.from(nav.querySelectorAll('a[href^="#"]')).map(link => {
            let id = link.hash.slice(1);
            try { id = decodeURIComponent(id); } catch (_) { /* A literal % is valid in an HTML id. */ }
            return { link, heading: doc.getElementById(id) };
        }).filter(entry => entry.heading);
        if (!entries.length) return;
        const reading = nav.closest('.ArticleReading');
        const reduced = win.matchMedia('(prefers-reduced-motion: reduce)');
        let scheduled = false;
        const offset = () => {
            const header = doc.querySelector('.Header');
            const fixed = header && ['sticky', 'fixed'].includes(win.getComputedStyle(header).position);
            const toolbar = doc.getElementById('wpadminbar');
            return 24 + (fixed ? header.getBoundingClientRect().height : 0) + (toolbar && win.getComputedStyle(toolbar).position === 'fixed' ? toolbar.getBoundingClientRect().height : 0);
        };
        const update = () => {
            scheduled = false;
            const top = offset();
            reading.style.setProperty('--article-scroll-offset', `${top}px`);
            let current = entries[0];
            for (const entry of entries) {
                if (entry.heading.getBoundingClientRect().top <= top + 48) current = entry;
            }
            entries.forEach(entry => {
                if (entry === current) entry.link.setAttribute('aria-current', 'location');
                else entry.link.removeAttribute('aria-current');
            });
        };
        const schedule = () => { if (!scheduled) { scheduled = true; win.requestAnimationFrame(update); } };
        nav.addEventListener('click', (event) => {
            const link = event.target.closest('a[href^="#"]');
            if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
            const entry = entries.find(item => item.link === link);
            if (!entry) return;
            event.preventDefault();
            reading.style.setProperty('--article-scroll-offset', `${offset()}px`);
            win.history.pushState(null, '', link.hash);
            entry.heading.focus({ preventScroll: true });
            entry.heading.scrollIntoView({ behavior: reduced.matches ? 'instant' : 'smooth', block: 'start' });
            schedule();
        });
        win.addEventListener('scroll', schedule, { passive: true });
        win.addEventListener('resize', schedule, { passive: true });
        win.addEventListener('hashchange', schedule);
        update();
    });
}
